import { AddBuildingToMarketplaceResultDto } from "../../../../networking/data/responses/marketplace/buildings/AddBuildingToMarketplaceResultDto";
import { MarketplaceBuildingPrice } from "../../marketplace/main/models/map/MarketplaceBuildingPrice";

export class MarketplaceListingInfo {
    public readonly id: string;
    public readonly area: number;
    public readonly price: MarketplaceBuildingPrice;

    public constructor(dto: AddBuildingToMarketplaceResultDto) {
        if (dto == undefined) {
            throw new Error("Failed to create MarketplaceListingInfo without AddBuildingToMarketplaceDto.");
        }
        if (dto.id == undefined || dto.id.length == 0) {
            throw new Error("Failed to create MarketplaceListingInfo without marketplace building id.");
        }
        if (isNaN(dto.area)) {
            throw new Error("Failed to create MarketplaceListingInfo without area id.");
        }
        if (dto.price == undefined) {
            throw new Error("Failed to create MarketplaceListingInfo without marketplace price info.");
        }
        this.id = dto.id;
        this.area = dto.area;
        this.price = new MarketplaceBuildingPrice(dto.price);
    }
}
